var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyable-field"},[_c('span',{staticClass:"copyable-field__text",class:{ 'copyable-field__text--copyable': !!_vm.value },attrs:{"title":_vm.value ? '双击复制' : ''},on:{"selectstart":_vm.handleSelectStart,"dblclick":_vm.handleDblClick}},[_vm._v(_vm._s(_vm.displayText))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00684a1a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CopyableField.vue
// module id = 2Nbp
// module chunks = 0